export default "__VITE_ASSET__CRmbHVvM__"